export default {
  /**
   * @name 特約作者
   */
  baseUrl: '/authors',
  index: {
    url: '',
  },
};
